module.exports = __webpack_public_path__ + "static/img/upmood-app-3.9204582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/upmood-app-3.jpg
// module id = 3+hv
// module chunks = 3